// extracted by mini-css-extract-plugin
module.exports = {"attention":"_ServiceItemSelect_attention__2hhIk"};